import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import { registerLocale } from "react-datepicker";
import id from 'date-fns/locale/id'

import Select from "react-select"
import { useEffect, useState } from "react";
import { getKabupaten, getKecamatan, getProvinsi, updateFormBiodata } from "./Api";
import { useDispatch, useSelector } from "react-redux";
import { setIsHomeProcess } from "../../app/GlobalSlice";
import { handleAxiosNetworkError, handleResponse200 } from "../../utils/HttpUtils";
import { notifyError, notifySuccess } from "../../utils/Notification";
import { useNavigate } from "react-router";
import { isPhone } from "../../utils/PlatformHelper";
import { logout } from "../../app/Api";

function toIsoDate(date) {
  return date.getFullYear() + '-' + padZero(date.getMonth() + 1) + '-' + padZero(date.getDate().toString())
}

function padZero(n) {
  return String(n).padStart(2, '0')
}

const FormAddress = ({
  onChangeValues
}) => {

  const [provOpts, setProvOpts] = useState({
    data: [],
    isLoad: false,
    selectedOpt: null
  })

  const [kabOpts, setKabOpts] = useState({
    data: [],
    isLoad: false,
    selectedOpt: null
  })

  const [kecOpts, setKecOpts] = useState({
    data: [],
    isLoad: false,
    selectedOpt: null
  })

  const [fullAddress, setFullAddress] = useState('')

  useEffect(() => {

    const payload = {
      provinsi: 
        provOpts.selectedOpt ?
          ({ id: provOpts.selectedOpt.value, label: provOpts.selectedOpt.label })
          :
          null,
      kabupaten: 
        kabOpts.selectedOpt ?
          ({ id: kabOpts.selectedOpt.value, label: kabOpts.selectedOpt.label })
          :
          null,
      kecamatan:
        kecOpts.selectedOpt ?
          ({ id: kecOpts.selectedOpt.value, label: kecOpts.selectedOpt.label })
          :
          null,
      fullAddress: fullAddress
    }

    onChangeValues(JSON.stringify(payload))

  }, [provOpts.selectedOpt, kabOpts.selectedOpt, kecOpts.selectedOpt, fullAddress])

  function onSelectProv() {
    setProvOpts({ ...provOpts, isLoad: true })

    getProvinsi()
      .then(res => {
        if (res.success) {
          setProvOpts({ ...provOpts, data: res.payload.map(r => ({ label: r.label, value: r.id })), isLoad: false })
        }
        else {

        }
      })
      .catch(handleAxiosNetworkError)
  }

  function onSelectKab() {
    setKabOpts({ ...kabOpts, isLoad: true })

    getKabupaten(provOpts.selectedOpt.value)
      .then(res => {
        if (res.success) {
          setKabOpts({ ...kabOpts, data: res.payload.map(r => ({ label: r.label, value: r.id })), isLoad: false })
        }
        else {

        }
      })
      .catch(handleAxiosNetworkError)
  }

  function onSelectKec() {
    setKecOpts({ ...kecOpts, isLoad: true })

    getKecamatan(kabOpts.selectedOpt.value)
      .then(res => {
        if (res.success) {
          setKecOpts({ ...kecOpts, data: res.payload.map(r => ({ label: r.label, value: r.id })), isLoad: false })
        }
        else {

        }
      })
      .catch(handleAxiosNetworkError)
  }

  return (
    <div className="space-y-3">
      <div className="py-2 flex flex-1 flex-col text-left text-sm">
        <label className="">Alamat Lengkap</label>
        <div
          className="py-1 h-full flex"
        >
          <textarea 
            className="w-full border border-gray-300 rounded-md outline-blue-500 p-2"
            value={fullAddress}
            onChange={e => setFullAddress(e.target.value)}
            rows={5}
          />
        </div>
      </div>
      <div className="py-2 flex flex-1 flex-col text-left text-sm">
        <label className="">Provinsi</label>
        <div
          className="py-1 h-full flex"
        >
          <Select
            value={provOpts.selectedOpt}
            options={provOpts.data}
            isLoading={provOpts.isLoad}
            menuPlacement="auto"
            className="w-full border border-gray-200 rounded-md"
            onFocus={onSelectProv}
            onChange={(value) => {
              setProvOpts({ ...provOpts, selectedOpt: value })
              setKabOpts({ ...kabOpts, selectedOpt: null })
              setKecOpts({ ...kecOpts, selectedOpt: null })
            }}
          />
        </div>
      </div>
      <div className="py-2 flex flex-1 flex-col text-left text-sm">
        <label className="">Kota/Kabupaten</label>
        <div
          className="py-1 h-full flex"
        >
          <Select
            value={kabOpts.selectedOpt}
            options={kabOpts.data}
            isLoading={kabOpts.isLoad}
            menuPlacement="auto"
            className="w-full border border-gray-200 rounded-md"
            onFocus={onSelectKab}
            onChange={(value) => {
              setKabOpts({ ...kabOpts, selectedOpt: value })
              setKecOpts({ ...kecOpts, selectedOpt: null })
            }}
          />
        </div>
      </div>
      <div className="py-2 flex flex-1 flex-col text-left text-sm">
        <label className="">Kecamatan</label>
        <div
          className="py-1 h-full flex"
        >
          <Select
            value={kecOpts.selectedOpt}
            options={kecOpts.data}
            isLoading={kecOpts.isLoad}
            menuPlacement="auto"
            className="w-full border border-gray-200 rounded-md"
            onFocus={onSelectKec}
            onChange={(value) => {
              setKecOpts({ ...kecOpts, selectedOpt: value })
            }}
          />
        </div>
      </div>
    </div>
  )

}

const FormField = ({
  field,
  value,
  onChange
}) => {

  return (
    <div
      className="space-y-2"
      style={{
        fontSize: '14px'
      }}
    >
      {field.fieldType !== 'address' && (
        <div>
          <div
          >
            {field.label} {field.isMandatory ? "*" : ""}
          </div>
          <div
            className="italic"
            style={{
              fontSize: '14px'
            }}
          >
            {field.description}
          </div>
        </div>
      )}
      <div
      >
        {
          field.fieldType === 'input_field' ?
            (<input 
                className="w-full p-2 border border-gray-300 rounded-md outline-blue-500"
                value={value}
                onChange={e => onChange(e.target.value)}
            />)
            :
            field.fieldType === 'dropdown' ?
              (
                <Select
                  placeholder="Pilih salah satu"
                  value={value}
                  options={field.values.map(v => ({ label: v, value: v }))}
                  menuPlacement="auto"
                  className="w-full border border-gray-200 rounded-md"
                  onChange={(value) => {
                    onChange(value)
                  }}
                />
              )
              :
              field.fieldType === 'radio_button' ?
                (<input />)
                :
                field.fieldType === 'text_area' ?
                  (<textarea 
                    className="w-full p-1.5 border border-gray-300 rounded-md outline-blue-500"
                    value={value}
                    rows={5}
                    onChange={e => onChange(e.target.value)}
                  />)
                  :
                  field.fieldType === 'date' ?
                    (<DatePicker 
                      locale={id}
                      className="w-full border border-gray-400 p-2" 
                      selected={value} 
                      onChange={(date) => onChange(date)} 
                      dateFormat="dd/MM/yyyy"
                    />)
                    :
                    field.fieldType === 'address' ?
                      (<FormAddress 
                          onChangeValues={onChange}
                      />)
                      :
                      (<div />)
        }
      </div>
    </div>
  )  

}

const FormBuilder = ({
  groupedFields
}) => {

  const { systemProfile, screenSize } = useSelector(state => state.global)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [inputForm, setInputForm] = useState([])
  const [flattenFormField, setFlattenFormField] = useState([])
  const [errors, setErrors] = useState([])

  useEffect(() => {
    setInputForm(
      [].concat.apply([], groupedFields.map(gf => gf.fields.map(f => ({ id: f.idForm, value: null }))))
    )
    
    setFlattenFormField([].concat.apply([], groupedFields.map(gf => gf.fields)))
  }, [groupedFields])

  if (groupedFields.length == 0 || inputForm.length == 0) {
    return null;
  }

  function onFinish() {
    const formPayload = 
      inputForm.map(f => ({ idField: f.id, value: getValueFromInputForm(f) }))

    dispatch(setIsHomeProcess(true))

    const payload = {
      form: formPayload,
    }

    updateFormBiodata(payload)
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: _ => {
            notifySuccess('Berhasil update biodata')

            if (systemProfile.companyPmbScheduleType === 'scheduled_by_admin_and_participant') {
              navigate("/home/schedule-test")
            }
            else if (systemProfile.companyPmbScheduleType === 'scheduled_by_admin_only') {
              navigate("/home/document")
            }
          },
          onRecovFailure: errors => {
            setErrors(errors)
            window.scrollTo(0, 10)
          },
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
            notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => dispatch(setIsHomeProcess(false)))
  }

  function getValueFromInputForm(inputF) {
    
    const temp = flattenFormField.find(f => inputF.id === f.idForm)
    if (temp.fieldType === 'dropdown') {
      return inputF.value ? inputF.value.value : null
    }
    else if (temp.fieldType === 'date') {
      return inputF.value ? toIsoDate(inputF.value) : null
    }
    else {
      return inputF.value
    }
  }

  function onLogout() {
    dispatch(setIsHomeProcess(true))

    logout()
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            notifySuccess('Logout Berhasil')
            navigate("/login")
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => { dispatch(setIsHomeProcess(false)) })
  }

  return (
    <div
      className="space-y-5 px-8"
    >
      {errors.length > 0 && (
        <div
          className="p-3 space-y-5 bg-red-600 text-white"
        >
          <ul>
            {errors.map(err => (
              <li className="py-0">{err}</li>
            ))}
          </ul>
        </div>
      )} 
      <div
        className="py-3 space-y-5"
      >
        {groupedFields.map(gf => (
          <div
            key={gf.gfFormGroupLabel}
            className="space-y-3"
          >
            <div
              className="p-2 rounded-sm shadow-lg bg-blue-500 text-white uppercase"
            >
              {gf.gfFormGroupLabel}
            </div>
            <div
              className="px-3 space-y-3"
            >
              {gf.fields.map(f => (
                <FormField
                  key={f.idForm}
                  field={f}
                  value={inputForm.find(ft => ft.id === f.idForm).value}
                  onChange={e => {
                    setInputForm(inputForm.map(ft => ft.id === f.idForm ? ({ ...ft, value: e }) : ft))
                  }}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
      
      <div
          className="py-5 flex justify-center"
        >
          <div
            className={
              "px-10 space-y-5" +
              (isPhone(screenSize.width) ? " w-full " : " w-2/3  ")
            }
          >
            <button
              className={
                "w-full py-1.5 rounded-md bg-blue-500 text-white "
              }
              style={{
                fontSize: '14px'
              }}
              onClick={onFinish}
            >
              Selesai
            </button>
            <button
              className="w-full border border-blue-500 py-1.5 rounded-md hover:bg-blue-500 hover:text-white"
              style={{
                fontSize: '14px'
              }}
              onClick={onLogout}
            >
              Keluar
            </button>
          </div>
        </div>

    </div>
  )
}

export default FormBuilder;